/* Copyright Airship and Contributors */
'use strict';
/**
 * Enum of internal subscription list update type.
 * @hidden
 */
var SubscriptionListOperationAction;
(function (SubscriptionListOperationAction) {
    SubscriptionListOperationAction["subscribe"] = "subscribe";
    SubscriptionListOperationAction["unsubscribe"] = "unsubscribe";
})(SubscriptionListOperationAction || (SubscriptionListOperationAction = {}));
/**
 * Subscription list editor.
 */
export class SubscriptionListEditor {
    constructor(onApply) {
        this.onApply = onApply;
        this.operations = [];
    }
    /**
     * Subscribes to a list.
     *
     * @param subscriptionListId The subscription list identifier.
     * @returns The editor
     */
    subscribe(subscriptionListId) {
        const operation = {
            listId: subscriptionListId,
            action: SubscriptionListOperationAction.subscribe,
        };
        this.operations.push(operation);
        return this;
    }
    /**
     * Unsubscribe from a list.
     *
     * @param subscriptionListId The subscription list identifier.
     * @returns The editor
     */
    unsubscribe(subscriptionListId) {
        const operation = {
            listId: subscriptionListId,
            action: SubscriptionListOperationAction.unsubscribe,
        };
        this.operations.push(operation);
        return this;
    }
    /**
     * Applies subscription list changes.
     *
     */
    apply() {
        return this.onApply(this.operations);
    }
}
//# sourceMappingURL=SubscriptionListEditor.js.map